.fr-upload-mod,
.fr-upload-file {
  display: flex;
}
.fr-upload-mod {
  align-items: center;
}
.fr-upload-mod .fr-upload-preview {
  margin: 0 12px;
}
.fr-upload-file .ant-upload-list-item {
  margin: 5px 0 0 8px;
}
.fr-upload-file .ant-upload-list-item-name {
  margin-right: 6px;
}
.fr-upload-file .ant-upload-list-item-info {
  cursor: pointer;
}
.fr-upload-file .next-upload-list-text .next-upload-list-item-done,
.fr-upload-file .next-upload-list-text .next-upload-list-item .next-icon {
  height: 28px;
  line-height: 28px;
  margin-left: 12px;
}
.fr-upload-file .next-upload-list-item-name-wrap {
  margin-top: -4px;
}
